export const MIN_LENGTH = 8;
export const MAX_LENGTH = 99;
const NUMBERS_REGEX = /[0-9]/;
const UPPERCASE_REGEX = /[A-Z]/;
const LOWERCASE_REGEX = /[a-z]/;
const SPECIAL_CHARACTER_REGEX = /(?=.*[!@#$%^&*.[\]{}()?|"\-,><':;_~])/;
const SPACES_REGEX = /\s/;
export interface PasswordErrors {
  minimumLength: boolean;
  maximumLength: boolean;
  number: boolean;
  upperCase: boolean;
  lowerCase: boolean;
  specialCharacter: boolean;
  containsSpaces: boolean;
}

export enum PasswordErrorKeys {
  minimumLength = 'minimumLength',
  number = 'number',
  upperCase = 'upperCase',
  lowerCase = 'lowerCase',
  specialCharacter = 'specialCharacter',
  containsSpaces = 'containsSpaces',
  maximumLength = 'maximumLength',
}

export const hasMinLength = (password: string): boolean => password.trim().length >= MIN_LENGTH;

export const hasMaxLength = (password: string): boolean => password.trim().length > MAX_LENGTH;

export const containsNumbers = (password: string): boolean => !!password.match(NUMBERS_REGEX);

export const containsUppercaseCharacters = (password: string): boolean => !!password.match(UPPERCASE_REGEX);

export const containsLowercaseCharacters = (password: string): boolean => !!password.match(LOWERCASE_REGEX);

export const containsSpecialCharacters = (password: string): boolean => !!password.match(SPECIAL_CHARACTER_REGEX);

export const containsSpaces = (password: string): boolean => !!password.match(SPACES_REGEX);

export const isValidPassword = (password: string): PasswordErrors => ({
  minimumLength: hasMinLength(password),
  number: containsNumbers(password),
  upperCase: containsUppercaseCharacters(password),
  lowerCase: containsLowercaseCharacters(password),
  specialCharacter: containsSpecialCharacters(password),
  containsSpaces: !containsSpaces(password),
  maximumLength: !hasMaxLength(password),
});
